import type { PricingPlanDTO, Type } from './ParagraphPricing.domain';

import type { FC } from 'react';
import { Pricing } from '@genially/public-web-components';
import { mapPricingPlans } from './mappers/mapPricingPlans';
import { snowplowWrapper } from 'core/services/snowplow';

interface ParagraphPricingProps {
  langcode: {
    value: string;
  };
  plans: PricingPlanDTO[];
  components: any;
  components2?: any;
  types: Type[];
  withoutFilters?: boolean;
}

export const ParagraphPricing: FC<ParagraphPricingProps> = ({
  langcode,
  plans,
  components,
  components2,
  types,
  withoutFilters = false,
}) => {
  // sendPageView function for filter clicks only (not on component mount)
  let sendPageView;
  if (!process.env.GATSBY_IS_LOCAL || process.env.GATSBY_IS_LOCAL === 'false') {
    sendPageView = () => {
      // Snowplow tracking for filter clicks only
      snowplowWrapper.initTracker();
      snowplowWrapper.sendPageViewEvent();
    };
  }
  return (
    <Pricing
      snowplowEvent={sendPageView ? sendPageView : undefined}
      plans={mapPricingPlans(plans, true, langcode.value)}
      types={types}
      components={components}
      components2={components2}
      withoutFilters={withoutFilters}
    />
  );
};
